import { FileText, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "../../../components/ui/button";

interface SmartProfileCardProps {
	/** Titles of the Smart Profiles on the account. Empty means no resume has been uploaded yet. */
	dspTitles: string[];
	/** Resumes built in the Dproz builder. A different thing from an uploaded resume. */
	resumeCount: number;
	onUploadResume: () => void;
}

/**
 * The second half of what the picks run on. Kept separate from the preferences card because the two
 * have different jobs: preferences shape which roles are found, a resume is what lets us score you
 * against one and apply on your behalf.
 */
function SmartProfileCard({ dspTitles, resumeCount, onUploadResume }: SmartProfileCardProps) {
	const hasSmartProfile = dspTitles.length > 0;

	return (
		<div className="bg-white rounded-lg border border-gray-200 p-6">
			<div className="flex items-center gap-2">
				<Sparkles className="size-4 text-primary-700" />
				<h2 className="text-base font-bold text-gray-900 font-plus-jakarta">Smart Profile</h2>
			</div>

			{hasSmartProfile ? (
				<>
					<div className="mt-4 space-y-2">
						{dspTitles.map((title) => (
							<div key={title} className="flex items-center gap-3 rounded-md bg-gray-50 px-3 py-2.5">
								<FileText className="size-4 shrink-0 text-primary-700" />
								<p className="text-sm font-medium text-gray-900 font-inter truncate">{title}</p>
							</div>
						))}
					</div>
					<Button variant="outlineSecondary" className="w-full mt-4" onClick={onUploadResume}>
						Add another resume
					</Button>
				</>
			) : (
				<>
					<p className="mt-2 text-sm text-gray-600 font-inter leading-relaxed">
						Upload your resume and we can score you against a job before you apply, and send the application from your
						own inbox.
					</p>
					<Button className="w-full mt-4" onClick={onUploadResume}>
						Upload your resume
					</Button>
				</>
			)}

			<div className="mt-5 pt-5 border-t border-gray-100 flex items-center justify-between gap-3">
				<p className="text-sm text-gray-600 font-inter">
					{resumeCount > 0
						? `${resumeCount} ${resumeCount === 1 ? "resume" : "resumes"} in the builder`
						: "No Dproz resume yet"}
				</p>
				<Link to="/my-resumes" className="text-sm font-medium text-primary-700 hover:underline underline-offset-4">
					{resumeCount > 0 ? "Manage" : "Build one"}
				</Link>
			</div>
		</div>
	);
}

export default SmartProfileCard;
